import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const SlaPage = lazy(() => import('./pages/SlaPage'));
const SkillRoutingPage = lazy(() => import('./pages/SkillRoutingPage'));
const TicketLinksPage = lazy(() => import('./pages/TicketLinksPage'));
const BulkActionsPage = lazy(() => import('./pages/BulkActionsPage'));
const TicketTemplatesPage = lazy(() => import('./pages/TicketTemplatesPage'));

export const AdvancedTicketsRoutes: RouteObject = {
  path: 'advanced-tickets',
  element: <ModuleGuard moduleId="support.advanced-tickets" />,
  handle: { crumb: 'Advanced Tickets' },
  children: [
    { index: true, element: <Navigate to="sla" replace /> },
    { path: 'sla', element: <SlaPage />, handle: { crumb: 'SLA' } },
    { path: 'skill-routing', element: <SkillRoutingPage />, handle: { crumb: 'Skill Routing' } },
    { path: 'ticket-links', element: <TicketLinksPage />, handle: { crumb: 'Ticket Links' } },
    { path: 'bulk-actions', element: <BulkActionsPage />, handle: { crumb: 'Bulk Actions' } },
    { path: 'ticket-templates', element: <TicketTemplatesPage />, handle: { crumb: 'Ticket Templates' } },
  ],
};
